<div class="offcanvas-header">
    <h5 class="offcanvas-title">{{ title }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
  </div>
  <div class="offcanvas-body">
    <p>{{ message }}</p>
    <div class="d-flex justify-content-end mt-4">
      <button class="secondaryBtn me-2" (click)="cancel()">{{ cancelText }}</button>
      <button class="primaryBtn" (click)="confirm()">{{ confirmText }}</button>
    </div>
  </div>